// extracted by mini-css-extract-plugin
module.exports = {"sectionBeAhead":"SectionBeAhead_sectionBeAhead_2uxRa"};